import { apiClient as api } from "./httpClient";

/**
 * Dados sensíveis do cadastro do paciente por perfil (RN-112q, item 118). A API já mascara o que
 * o perfil não vê; estas flags servem para a tela sinalizar o campo (cadeado + "Restrito") e
 * esconder os links de WhatsApp e e-mail. Perfil sem configuração = tudo bloqueado.
 */
export interface SensitiveDataFlags {
  documents: boolean;
  emails: boolean;
  phones: boolean;
  addresses: boolean;
  healthPlan: boolean;
  /** pode editar o cadastro existente (criar é a permissão patient-create) */
  editRegister: boolean;
}

export type SensitiveGroup = keyof SensitiveDataFlags;

export const ALL_BLOCKED: SensitiveDataFlags = {
  documents: false,
  emails: false,
  phones: false,
  addresses: false,
  healthPlan: false,
  editRegister: false,
};

export interface ProfileSensitiveDataRow {
  profileId: string;
  profileName: string;
  active: boolean;
  flags: SensitiveDataFlags;
  /** false = perfil ainda no padrão de fábrica (tudo bloqueado) */
  configured: boolean;
}

export const patientSensitiveDataService = {
  async getAll(): Promise<ProfileSensitiveDataRow[]> {
    const response = await api.get("/patient-sensitive-data");
    return response.data;
  },
  async save(profileId: string, flags: SensitiveDataFlags): Promise<void> {
    await api.put(`/patient-sensitive-data/${profileId}`, flags);
  },
  async mine(): Promise<SensitiveDataFlags> {
    const response = await api.get("/patient-sensitive-data/mine");
    return response.data;
  },
};
